import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { DocumentPreviewUI, openDocumentPreview } from "../../../components/document-preview";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import { callGetSpecialAgentCommision, callApproveRejectedSpecialAgentCommision } from "../../../api/settings/service";
import { callGetLifeInsuranceClaiming } from "../../../api/insurances/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { convertStringToJson, dateToString, displayUrl, encodeBase64, handleGetCookie } from "../../../utils/commonUtil";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
import colors from '../../../utils/colors';
import moment from "moment";
import statusItems from "../../../data/agentSpecial"
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import { APPROVE, CANCEL } from "../../../utils/commonType";
import SmartTable from "../../../components/common/table-component";
import { useLocation, useNavigate } from "react-router-dom";
import { approveClameLifeContract } from "../../../api/contract/service";
import SwalAlert from "../../../components/common/alert";

const SpecialAgentCommision = () => {
	let baseUrl = "/admin/setting/agentSpecialCommision/save";
	const navigate = useNavigate();
	const userInfo = useSelector((state) => state.dataLogin);

	const { pathname } = useLocation();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, contractNumber: '', updateBy: '', status: '', reason: '', id: null, agentCode: '' });
	const [lifeInsurance, setLifeInsurance] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [showReason, setShowReason] = useState(false);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const location = useLocation();


	useEffect(() => {
		loadData();
	}, [location.state]);
	const columns = [
		{
			label: 'claimLifeContractNumber', key: 'contractNumber', style: { width: '200px' }

		},
		{
			label: 'claimLifeStatus', style: { width: '50px' }, key: 'status', render: (val) => (
				val === 1 ? <span className="badge bg-warning">{t('statusClame.' + val)}</span> :
					val === 0 ? <span className="badge bg-danger">{t('statusClame.' + val)}</span> :
						<span className="badge bg-success">{t('statusClame.' + val)}</span>
			)
		},
		{
			label: 'claimLifeRequestDate', style: { width: '50px' }, key: 'carriredDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},

		{ label: 'claimLifeDescription', style: { width: '200px' }, key: 'description' },

		{
			label: 'claimLifeFullName', style: { width: '200px' }, key: 'firstName', render: (val, item) => (
				item.firstName + ' ' + item.lastName
			)
		},
		{
			label: 'claimLifeDeadDate', style: { width: '50px' }, key: 'deadDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'claimLifeReasonDead', key: 'claimCause', render: (val) => (
				val ? t('causeList.' + val) : '-'
			)
		}
		, {
			label: 'claimLifeApprovedDoc', key: 'approvedPath', render: (val) => {
				try {
					return val && <DocumentPreviewUI documents={convertStringToJson(val)} variant="cell" />
				} catch (error) {
					return ''
				}
			}

		}
		, {
			label: 'claimLifeDocumentBeneficiary', key: 'beneficiaryDocumentPath', render: (val) => {
				try {
					return val && <DocumentPreviewUI documents={convertStringToJson(val)} variant="cell" />
				} catch (error) {
					return ''
				}
			}

		}
		, {
			label: 'claimLifeDocumentDead', key: 'documentPath', render: (val) => {
				try {
					return val && <DocumentPreviewUI documents={convertStringToJson(val)} variant="cell" />
				} catch (error) {
					return ''
				}
			}
		},
	];

	const openFile = (e, value) => {
		e.preventDefault();
		if (value) openDocumentPreview(value, { title: __t("uiText.text094") });
	}

	// const loadData = async () => {
	// 	let data = {
	// 		page: request.page,
	// 		maxResult: request.maxResult,
	// 		contractNumber: request.contractNumber,
	// 		status: request.status,
	// 		fromDate: request.fromDate,
	// 		toDate: request.toDate
	// 	};
	// 	const rsp = await dispatch(callGetLifeInsuranceClaiming(data));
	// 	console.log(rsp)
	// 	if (rsp?.payload?.responseCode === "00000") {
	// 		setLifeInsurance(rsp.payload.data.result);
	// 		setTotalPages(rsp.payload.data.totalPages);
	// 		setTotalRecord(rsp.payload.data.totalRecords);
	// 	}
	// };
	const loadData = async (e) => {
		let data = {
			page: request.page,
			maxResult: request.maxResult,
			contractNumber: request.contractNumber,
			status: request.status,
			fromDate: fromDate,
			toDate: toDate
		};
		if (e) {
			setRequest((prev) => ({
				...prev,
				page: e.page,
				maxResult: e.maxResult
			}));
			data.page = e.page
			data.maxResult = e.maxResult
		}
		const rsp = await dispatch(callGetLifeInsuranceClaiming(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)
		}

	}

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, contractNumber: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault();
		loadData();
	};

	const handleClose = () => {
		setShowReason(false)
	}

	const handleApprovedRejected = (item, status) => {
		setShowReason(true)
		setRequest((prev) => ({
			...prev,
			status,
			reason: "",
			id: item.id,
			agentCode: item.agentCode
		}));
	};

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	const handleChangeReason = (e) => {
		setRequest((prev) => ({ ...prev, reason: e.target.value }));
	};

	const handleSave = (e) => {
		e.preventDefault();
		SwalAlert.confirm(t("swal.title.reject"), t("swal.text.confirmReject"), async () => {
			try {
				let req = {
					id: request.id,
					status: request.status,
					description: request.reason,
					modifiedCode: userInfo?.data?.user?.userId,
					modifiedName: `${userInfo?.data?.user?.firstName} ${userInfo?.data?.user?.lastName || ''}`
				}
				const rsp = await dispatch(approveClameLifeContract(req));
				if (rsp?.payload?.responseCode === "00000") {
					setShowReason(false)
					loadData()
				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}

	const handleOpenBeneficiaryFile = (file) => {
		openDocumentPreview(file, { title: __t("uiText.text094") });
	}
	const handleApprove = (id, view = false) => {
		navigate(pathname + "/approveLifeInsurance/" + encodeBase64(JSON.stringify({ id: id.id, view: view })))
	}

	const handleOpenDocumentFile = (file) => {
		openDocumentPreview(file, { title: __t("uiText.text094") });
	}

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.approved.lifeInsurance")}</h4>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={fromDate}
														onChange={date => setFromDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toDate}
														onChange={date => setToDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-3 form-group">
													<label>{t('search.contractNumber')}</label>
													<input
														type="text"
														name="contractNumber"
														className="form-control-uld"
														placeholder={t('search.contractNumber') + "..."}
														onChange={handleChange}
														value={request.contractNumber}
														autoComplete="off"
													/>
												</div>

												<div className="col-md-3 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															statusItems.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>

												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData}
											actions={(item) => (
												<div style={{ minWidth: 150 }}>
													<PermissionWrapper permission={APPROVE}>
														<button disabled={item.status != 1} className="btn btn-success btn-sm" onClick={() => handleApprove(item)}>
															<i className="fas fa-check"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={APPROVE}>
														<button disabled={item.status == 1} className="btn btn-primary btn-sm" onClick={() => { handleApprove(item, true) }} >
															<i className="fas fa-history"></i>
														</button>
													</PermissionWrapper>
													&nbsp;

													<PermissionWrapper permission={CANCEL}>
														<button disabled={item.status != 1} className="btn btn-primary btn-sm" onClick={() => { handleApprovedRejected(item, 0) }} >
															<i className="fas fa-times-circle"></i>
														</button>
													</PermissionWrapper>
												</div>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Modal show={showReason} onHide={handleClose}>
						<Modal.Header closeButton>
							<Modal.Title>
								{

									t("approved.rejectedTitle")
								}

							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<form onSubmit={handleSave}>
								<div className="row">
									<div className="default-form">
										<div className="col-12 form-group">
											<label> {t('settings.agentSpecialCommission.reason')} <span className="text-danger">*</span> </label>
											<textarea
												name="reason"
												placeholder={t('settings.agentSpecialCommission.reason')}
												value={request.reason}
												onChange={handleChangeReason}
												required>
											</textarea>
										</div>
										<div className="col-12 d-flex justify-content-end">
											<button className="btn btn-success" type="submit">
												{t("button.save")}
											</button>
										</div>
									</div>
								</div>
							</form>
						</Modal.Body>
					</Modal>

				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default SpecialAgentCommision;
